import * as actions from "../slices/orderHistorySlice";
import { call, put, takeEvery } from "redux-saga/effects";
import orderHistoryApis from "src/api/orderHistory";
import { common } from "src/types";
import { constants } from "src/constants/common";

const GetOrderHistorySaga = function* GetOrderHistorySaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}): Generator<any, void, any> {
  try {
    const response: common.ResponseGenerator = yield call(
      orderHistoryApis.getOrderHistory,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getOrderHistorySuccess(response?.data));
    resolve(response);
  } catch (error: any) {
    yield put(
      actions.getOrderHistoryError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* orderHistorySaga(): Generator<any, void, any> {
  yield takeEvery(actions.getOrderHistoryRequest, GetOrderHistorySaga);
}
